import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

// Traced from the DIO-1119 mockup, on its pixel grid
const MegaphoneIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="2.25 3 40 40"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <defs>
      <mask id="dio-megaphone-slit">
        <rect width="46" height="46" fill="white" />
        <path d="M10.8 31.2L18.6 19.6" stroke="black" strokeWidth={2.6} />
      </mask>
    </defs>
    <path
      d="M18.3 9L35.7 27L9.5 39.5L4.6 33Z"
      fill="currentColor"
      strokeWidth={2.4}
      mask="url(#dio-megaphone-slit)"
    />
    <rect
      x="14.2"
      y="34.7"
      width="13.6"
      height="5.6"
      rx="2.2"
      strokeWidth={2.4}
      transform="rotate(-24 21 37.5)"
    />
    <path d="M26.5 9.5L28.5 4.5M33.5 10L39.5 4.5M35.5 18L40.5 16" strokeWidth={2.6} />
  </ChakraIcon>
)

export default MegaphoneIcon
